import { StatsReportsIdsEnum } from '@empathybroker/tsclient-stats/dist/enums/stats-reports-ids.enum';
import { RelatedResponse } from '@empathybroker/tsclient-stats/dist/models/related/related.response';

import { ActionContext } from 'vuex';

import { RelatedTypeEnum } from '../../../enums';

import { ActionClass, AnalyticsState, Pagination } from '../../../models';

import { ANALYTICS_CONSTS } from '../analytics.consts';

export class LoadRelatedDataAction implements ActionClass {

  public static async execute({ dispatch, commit, state }: ActionContext<AnalyticsState, any>,
    payload: { selectedId: string; type: RelatedTypeEnum; pagination: Pagination; }): Promise<RelatedResponse> {
    const selectedIdData = state.data.ids[payload.selectedId];
    let relatedData;
    if (!!selectedIdData) {
      relatedData = selectedIdData.related[payload.type];
    }
    const offset = ((payload.pagination.page - 1) * payload.pagination.itemsPerPage);
    if (!relatedData || ((relatedData.params.rows !== payload.pagination.itemsPerPage) || (relatedData.params.offset !== offset))) {
      const reportId = {
        [RelatedTypeEnum.CLICK]: StatsReportsIdsEnum.RELATED_CLICK,
        [RelatedTypeEnum.ADD2CART]: StatsReportsIdsEnum.RELATED_ADD2CART
      }[payload.type];
      try {
        relatedData = await dispatch(ANALYTICS_CONSTS.actions.fetchStatsReport, {
          id: reportId,
          params: {
            terms: payload.selectedId,
            rows: payload.pagination.itemsPerPage,
            offset: offset
          }
        });
        commit(ANALYTICS_CONSTS.mutations.setRelatedData, {
          data: relatedData,
          selectedId: payload.selectedId,
          relatedType: payload.type
        });
      } catch (error) {
        throw error;
      }
    }
    return relatedData;
  }

}
